import { createContext, useContext, useEffect, useState } from "react";
import { STRINGS } from "./translations";

const LangContext = createContext({ lang: "fr", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "fr";
        return localStorage.getItem("pdl_lang") || "fr";
    });

    useEffect(() => {
        try { localStorage.setItem("pdl_lang", lang); } catch (_) {}
        if (typeof document !== "undefined") document.documentElement.lang = lang;
    }, [lang]);

    const t = (key) => {
        const dict = STRINGS[lang] || STRINGS.fr;
        return dict[key] ?? STRINGS.fr[key] ?? key;
    };

    return (
        <LangContext.Provider value={{ lang, setLang: setLangState, t }}>
            {children}
        </LangContext.Provider>
    );
}

export function useLang() {
    return useContext(LangContext);
}
